export const getOrderPath = (orderId: string): string => {
  return `/orders/${orderId}`
}